<template>
  <qc-dialog class="tc-15-rich-dialog cos operate-dialog" :show="innerShow" type="custom" :width="500"
    @close="closeDialog" :default-cancel="false" :append-to-body="true" :close-triggers="[]">

    <!-- tab strat -->
    <div class="tc-15-tab cos-rich-dialog-tab">
      <ul class="tc-15-tablist">
        <li v-for="(tabItem,index) in tabList" :key="`setting-${index}`" :class="{'tc-cur':index===tabActive}">
          <a :title="tabItem" href="javascript:void(0);" @click="tabActive=index">{{tabItem}}</a>
        </li>
      </ul>

      <div class="tab-panel active">

        <!-- tab 通用 start -->
        <general-setting ref="generalSetting" v-show="tabActive==='generalSetting'"
          :disabled-btn.sync="disabledGeneralBtn">
        </general-setting>
        <!-- tab 通用 end -->

        <!-- tab 关于 start -->
        <about-setting v-show="tabActive==='aboutSetting'"></about-setting>
        <!-- tab 关于 end -->

        <!-- tab 上传 start -->
        <upload-setting ref="uploadSetting" v-show="tabActive==='uploadSetting'"
          :disabled-btn.sync="disabledUploadBtn" />
        <!-- tab 上传 end -->

        <div class="justify-grid" v-show="this.tabActive!=='aboutSetting'">
          <div class="col"></div>
          <div class="col">
            <qc-button class="mr-5" type="weak" size="short" @click="resetDefaultValue">{{$t('cos.reset_default')}}
            </qc-button>
            <qc-button type="default" size="short" :disabled="disabledBtn" @click="save">{{$t('core.save')}}</qc-button>

          </div>
        </div>

      </div>

    </div>
    <!-- tab end -->

    <qc-button type="icon" :title="$t('core.close')" class="operate-dialog-close" @click="closeDialog">
      <qc-icon type="close"></qc-icon>
    </qc-button>

  </qc-dialog>
</template>

<script>
import { getInnerProps } from '@/scripts/tools/utils';

import aboutSetting from './aboutSetting.vue';
import generalSetting from './generalSetting.vue';
import uploadSetting from './uploadSetting.vue';

export default {
  components: {
    aboutSetting,
    generalSetting,
    uploadSetting,
  },
  props: {
    show: {
      required: true,
      default: false,
    },
  },
  data() {
    const tabActive = 'aboutSetting';
    const tabList = {
      aboutSetting: this.$t('cos.about'),
      generalSetting: this.$t('cos.general'),
      uploadSetting: this.$t('core.upload'),
    };

    return {
      tabActive,
      tabList,
      // 禁用保存按钮
      disabledGeneralBtn: true,
      disabledUploadBtn: true,
    };
  },
  computed: {
    innerShow: getInnerProps('show'),
    disabledBtn() {
      return this.tabActive === 'generalSetting' && this.disabledGeneralBtn;
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.tabActive = 'aboutSetting';
      }
    },
  },
  methods: {
    resetDefaultValue() {
      this.$refs[this.tabActive].resetDefaultValue();
    },
    save() {
      this.$refs[this.tabActive].save();
    },
    closeDialog() {
      this.innerShow = false;
      this.disabledGeneralBtn = true;
      this.disabledUploadBtn = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.operate-dialog {
  .tc-15-tab {
    height: 420px;
    overflow: hidden;

    .tc-15-tablist {
      float: left;
      width: 15%;
      height: 100%;
      box-sizing: border-box;
      border-right: 1px solid #ddd;
      border-bottom: 0;
      padding: 0;
      padding-top: 24px;

      li {
        display: block;
        margin-left: 0;

        &.tc-cur {
          a {
            border-right: 2px solid #006eff;
            border-bottom: 2px solid transparent;
          }
        }
        a {
          display: block;
          margin-left: 0;
          padding: 0 16px;
          text-align: left;
          font-size: 12px;

          &:hover {
            border-right: 2px solid #006eff;
            border-bottom: 2px solid transparent;
          }
        }
      }
    }

    .tab-panel {
      float: right;
      width: 85%;
      height: 100%;
      padding-top: 34px;
      overflow-y: auto;
    }
  }
}
</style>
